import { useQuery } from '@tanstack/react-query';
import { TodosRequests } from 'src/requests/todos';
import { QueryKey, queryRetry } from 'src/utils/react-query';

export const useTagsQuery = (defaultTodoList: string) => {
  const {
    data: tags = [],
    isLoading: isTagsLoading,
    isFetching: isTagsFetching,
    refetch,
  } = useQuery(
    [QueryKey.TAGS, defaultTodoList],
    () => TodosRequests.getTagsByTodoGroup({ list: defaultTodoList }),
    {
      enabled: !!defaultTodoList,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchInterval: 1000 * 60 * 5,
      retry: queryRetry,
    },
  );

  return {
    tags,
    refetch,
    isTagsFetching,
    isTagsLoading,
  };
};
